import React from 'react';
import { Input } from '@tencent/tea-component';
export function BuyInput(_a) {
    var placeholder = _a.placeholder, disabled = _a.disabled, readonly = _a.readonly, maxLength = _a.maxLength, type = _a.type, size = _a.size, value = _a.value, onChange = _a.onChange, multiline = _a.multiline;
    return (React.createElement("div", { className: "tea-for-buy" },
        React.createElement("div", { className: "tea-form" },
            React.createElement(Input, { placeholder: placeholder, disabled: disabled, readonly: readonly, maxLength: maxLength, type: type, size: size, value: value, onChange: onChange, multiline: multiline }))));
}
//# sourceMappingURL=BuyInput.js.map